import * as React from 'react';
import { getChecked } from './utils/utils';
export const PrettyInput = React.forwardRef(({ onChange, disabled, value, state, locked, type, name, checked, defaultChecked, defaultValue, baseId, }, ref) => {
    return (React.createElement("input", { onChange: onChange, type: type, value: value, name: name, id: baseId, tabIndex: -1, ref: ref, defaultChecked: defaultChecked, defaultValue: defaultValue, checked: typeof checked === 'undefined'
            ? getChecked({ state, value, disabled, locked, type })
            : checked, disabled: disabled }));
});
PrettyInput.displayName = 'Pretty.Input';
